import React, { useState, useEffect } from 'react';
import {
  Accordion, Table, Badge, Alert, Form, Row, Col, Button, InputGroup, Modal
} from 'react-bootstrap';
import { FaPlus, FaEdit, FaTrash, FaCheck, FaTimes } from 'react-icons/fa';
import axios from 'axios';

const GDPRInventoryTab = ({ userData, onScoreUpdate, showNotification, region, refreshActivities,logToAccessLogs  }) => {
  const [inventoryItems, setInventoryItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [newItem, setNewItem] = useState({
  processingActivityName: '',
  dataType: '',
  classification: 'Personal Data',
  owner: '',
  dataSubjectCategory: '',
  processorThirdParty: '',
  purpose: '',
  retention: '',
  location: '',
  encryptedAtRest: false,
  encryptedInTransit: false,
  legalBasis: '',
  dataSubjects: []
});

  const headers = {
    Region: region,
    UserId: userData?.['cognito:username'] 
  };

  useEffect(() => {
    fetchInventoryItems();
  }, []);

  const fetchInventoryItems = async () => {
    try {
      const res = await axios.get('https://u3fhvjdru0.execute-api.ap-southeast-2.amazonaws.com/prod/api/gdpr/inventory/list', { headers });
      setInventoryItems(res.data);
      calculateComplianceScore(res.data);
    } catch (error) {
      console.error('Error fetching inventory:', error);
    }
  };

  const calculateComplianceScore = (items) => {
    if (items.length === 0) {
      onScoreUpdate(0);
      return;
    }

    const fullyCompliant = items.filter(item => 
     item.processingActivityName &&
item.dataType &&
item.classification &&
item.owner &&
item.dataSubjectCategory &&
item.processorThirdParty &&
item.purpose &&
item.legalBasis &&
item.retention
    ).length;

    const score = Math.round((fullyCompliant / items.length) * 100);
    onScoreUpdate(score);
  };

  const handleSave = async () => {
  try {
    const payload = { ...newItem };

    if (editingItem) {
      await axios.put(
        `https://5zmw6a4yya.execute-api.ap-southeast-2.amazonaws.com/prod/api/gdpr/inventory/update/${editingItem.id}`,
        payload,
        { headers }
      );
      await logActivity(`Updated inventory item: ${payload.dataType}`, 'warning');

      logToAccessLogs?.({
        action:      'Data Asset Updated',
        severity:    'warning',
        description: `Updated data asset: ${newItem.dataType} (${newItem.classification})`,
        metadata: {
          dataType:       newItem.dataType,
          classification: newItem.classification,
          owner:          newItem.owner,
          assetId:        editingItem.id,
        }
      });

    } else {
      await axios.post(
        'https://b69wd6yh31.execute-api.ap-southeast-2.amazonaws.com/prod/api/gdpr/inventory/create',
        payload,
        { headers }
      );
      await logActivity(`Added new inventory item: ${payload.dataType}`, 'success');

      logToAccessLogs?.({
        action:      'Data Asset Created',
        severity:    'success',
        description: `Created data asset: ${newItem.dataType} (${newItem.classification})`,
        metadata: {
          dataType:       newItem.dataType,
          classification: newItem.classification,
          owner:          newItem.owner,
        }
      });
    }

    showNotification('Inventory item saved successfully!');
    fetchInventoryItems();
    resetForm();

  } catch (error) {
    console.error('Error saving inventory item:', error);
    showNotification('Error saving inventory item', 'danger');
  }
};

const handleDelete = async (id) => {
  if (window.confirm('Are you sure you want to delete this item?')) {
    try {
      await axios.delete(`https://fj25p53fnh.execute-api.ap-southeast-2.amazonaws.com/prod/api/gdpr/inventory/delete/${id}`, { headers });
      await logActivity(`Deleted inventory item`, "danger");
      logToAccessLogs?.({
  action:      'Data Asset Deleted',
  severity:    'critical',
  description: `Deleted data asset with ID: ${id}`,});
      showNotification('Item deleted successfully!');
      fetchInventoryItems();
    } catch (error) {
      console.error('Error deleting item:', error);
      showNotification('Error deleting item', 'danger');
    }
  }
};


  const resetForm = () => {
    setNewItem({
  processingActivityName: '',
  dataType: '',
  classification: 'Personal Data',
  owner: '',
  dataSubjectCategory: '',
  processorThirdParty: '',
  purpose: '',
  retention: '',
  location: '',
  encryptedAtRest: false,
  encryptedInTransit: false,
  legalBasis: '',
  dataSubjects: []
});
    setEditingItem(null);
    setShowModal(false);
  };

const logActivity = async (message, badge = "info") => {
 
  
  try {
    // âœ… Map frontend fields to backend entity fields
    const payload = {
      action: badge,                    // badge â†’ action
      module: "Inventory",              // Add module field
      details: message                  // message â†’ details
      // userId and timestamp set by backend
    };
    
    
    
    const response = await axios.post(
      "https://w8wvx2z3f4.execute-api.ap-southeast-2.amazonaws.com/prod/api/activity-log/save",  // âœ… Correct endpoint
      payload,     
      { headers }  // âœ… Send headers properly
    );
    
    
    if (refreshActivities) {
        await refreshActivities();
      }


  } catch (err) {
    console.error('âŒ Error logging inventory activity:', err);
    
    if (err.response) {
      console.error('ðŸ”¥ Server Error Details:');
      console.error('Status:', err.response.status);
      console.error('Data:', err.response.data);
    }
    
    console.warn("Failed to log activity:", err.message);
  }
};


  const [activeAccordionKey, setActiveAccordionKey] = useState(null);


  return ( 
    <>
      <div className="border rounded">
  <div
    className="d-flex justify-content-between align-items-center p-3"
    style={{ cursor: "pointer" }}
    onClick={() =>
      setActiveAccordionKey(activeAccordionKey === "0" ? null : "0")
    }
  >
    <h6>Data Inventory Management</h6>
    <span>{activeAccordionKey === "0" ? "â–²" : "â–¼"}</span>
  </div>

  {activeAccordionKey === "0" && (
    <div className="p-3 border-top">
            <Row className="mb-3">
              <Col>
                <Button variant="primary" onClick={() => setShowModal(true)}>
                  <FaPlus /> Add New Data Asset
                </Button>
              </Col>
            </Row>

            <Table striped bordered hover responsive>
              <thead>
                <tr>
                 <th>Processing Activity</th>
<th>Data Type</th>
                  <th>Classification</th>
                  <th>Data Controller</th>
                  <th>Data Subjects</th>
<th>Processor / Third Party</th>
                  <th>Purpose</th>
                  <th>Legal Basis</th>
                  <th>Retention</th>
                  <th>Location</th>
                  <th>Encrypted</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {inventoryItems.map((item, index) => (
                  <tr key={index}>
                    <td>{item.processingActivityName || '-'}</td>
                    <td>{item.dataType}</td>
                    
                    <td>
                      <Badge bg={
                        item.classification === 'Special Category' ? 'danger' :
                        item.classification === 'Personal Data' ? 'warning' : 'info'
                      }>
                        {item.classification}
                      </Badge>
                    </td>
                    <td>{item.owner}</td>
                    <td>{item.dataSubjectCategory || '-'}</td>
<td>{item.processorThirdParty || '-'}</td>
                    <td>{item.purpose}</td>
                    <td>{item.legalBasis}</td>
                    <td>{item.retention}</td>
                    <td>{item.location}</td>
                    <td>
                      At Rest: {item.encryptedAtRest ? <FaCheck className="text-success" /> : <FaTimes className="text-danger" />}<br/>
                      In Transit: {item.encryptedInTransit ? <FaCheck className="text-success" /> : <FaTimes className="text-danger" />}
                    </td>
                    <td>
                      <Button size="sm" variant="outline-warning" className="me-1" 
                              onClick={() => { setEditingItem(item); setNewItem(item); setShowModal(true); }}>
                        <FaEdit />
                      </Button>
                      <Button size="sm" variant="outline-danger" onClick={() => handleDelete(item.id)}>
                        <FaTrash />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
  )}
  </div>

      <Modal show={showModal} onHide={resetForm} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{editingItem ? 'Edit' : 'Add'} Data Asset</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
          <Row>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Processing Activity Name</Form.Label>
      <Form.Control
        type="text"
        value={newItem.processingActivityName}
        onChange={(e) =>
          setNewItem({ ...newItem, processingActivityName: e.target.value })
        }
        placeholder="e.g., Customer Onboarding, Payroll Processing"
      />
    </Form.Group>
  </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Data Type</Form.Label>
                  <Form.Control
                    type="text"
                    value={newItem.dataType}
                    onChange={(e) => setNewItem({...newItem, dataType: e.target.value})}
                    placeholder="e.g., Customer Email Addresses"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Classification</Form.Label>
                  <Form.Select
                    value={newItem.classification}
                    onChange={(e) => setNewItem({...newItem, classification: e.target.value})}
                  >
                    <option value="Personal Data">Personal Data</option>
                    <option value="Special Category">Special Category Data</option>
                    <option value="Criminal Conviction">Criminal Conviction Data</option>
                    <option value="Pseudonymized">Pseudonymized Data</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Data Controller</Form.Label>
                  <Form.Control
                    type="text"
                    value={newItem.owner}
                    onChange={(e) => setNewItem({...newItem, owner: e.target.value})}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Legal Basis</Form.Label>
                  <Form.Select
                    value={newItem.legalBasis}
                    onChange={(e) => setNewItem({...newItem, legalBasis: e.target.value})}
                  >
                    <option value="">Select Legal Basis</option>
                    <option value="Consent">Consent</option>
                    <option value="Contract">Contract</option>
                    <option value="Legal Obligation">Legal Obligation</option>
                    <option value="Vital Interests">Vital Interests</option>
                    <option value="Public Task">Public Task</option>
                    <option value="Legitimate Interests">Legitimate Interests</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Data Subject Category</Form.Label>
      <Form.Select
        value={newItem.dataSubjectCategory}
        onChange={(e) =>
          setNewItem({ ...newItem, dataSubjectCategory: e.target.value })
        }
      >
        <option value="">Select Data Subject</option>
        <option value="Customers">Customers</option>
        <option value="Employees">Employees</option>
        <option value="Children">Children</option>
        <option value="Vendors">Vendors</option>
        <option value="Website Visitors">Website Visitors</option>
        <option value="Partners">Partners</option>
      </Form.Select>
    </Form.Group>
  </Col>

  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Processor / Third Party</Form.Label>
      <Form.Control
        type="text"
        value={newItem.processorThirdParty}
        onChange={(e) =>
          setNewItem({ ...newItem, processorThirdParty: e.target.value })
        }
        placeholder="Example: Internal Only, AWS, Salesforce, Zendesk"
      />
    </Form.Group>
  </Col>
</Row>
            <Form.Group className="mb-3">
              <Form.Label>Processing Purpose</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={newItem.purpose}
                onChange={(e) => setNewItem({...newItem, purpose: e.target.value})}
              />
            </Form.Group>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Retention Period</Form.Label>
                  <Form.Control
                    type="text"
                    value={newItem.retention}
                    onChange={(e) => setNewItem({...newItem, retention: e.target.value})}
                    placeholder="e.g., 2 years after contract ends"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Storage Location</Form.Label>
                  <Form.Control
                    type="text"
                    value={newItem.location}
                    onChange={(e) => setNewItem({...newItem, location: e.target.value})}
                    placeholder="e.g., EU-West-1 (AWS)"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Check
                  type="checkbox"
                  label="Encrypted at Rest"
                  checked={newItem.encryptedAtRest}
                  onChange={(e) => setNewItem({...newItem, encryptedAtRest: e.target.checked})}
                />
              </Col>
              <Col md={6}>
                <Form.Check
                  type="checkbox"
                  label="Encrypted in Transit"
                  checked={newItem.encryptedInTransit}
                  onChange={(e) => setNewItem({...newItem, encryptedInTransit: e.target.checked})}
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={resetForm}>Cancel</Button>
          <Button variant="primary" onClick={handleSave}>
            {editingItem ? 'Update' : 'Create'} Asset
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default GDPRInventoryTab;